import { el } from "@dhx/ts-common/dom";

export function title(item: any, widgetName: string) {
	return el(
		"span",
		{
			class: "dhx_navbar-title" + " dhx_navbar-title--" + widgetName,
			dhx_id: item.id,
			".innerHTML": item.html,
			"aria-label": item.value || "", // without label span is not accessible
		},
		!item.html ? item.value : null
	);
}
